import React, { useContext } from 'react';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import { DataList, Loader, CustomModal, ModalContext } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import useFilter from './useFilter';
import { columnConfigs } from './listConfig';

const GamePlayList: React.FC<{}> = () => {
	const { modalConfig } = useContext(ModalContext);

	const { showLoader, getGameplayData, setChangeFilter, forceUpdate, getGameName } = useFilter();
	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				{!modalConfig.isOpen && (
					<div
						className={css({
							display: 'flex',
							justifyContent: 'center',
							gap: '5px'
						})}>
						<div
							className={css({
								fontSize: '16px',
								fontWeight: 'bold'
							})}>
							Game:
						</div>
						<div>{getGameName()}</div>
					</div>
				)}
				<Button
					kind='primary'
					size='compact'
					onClick={() => {
						setChangeFilter(true);
					}}>
					Change Filter
				</Button>
			</div>
			<DataList
				fetchData={getGameplayData}
				columnConfigs={columnConfigs}
				hideActions
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.GAMEPLAY}
				globalForceUpdate={forceUpdate}
				height='calc(100vh - 220px)'
				filterable={false}
			/>
			<CustomModal />
		</>
	);
};

export default GamePlayList;
